module.exports = __webpack_public_path__ + "static/media/a2hsIOS.57b55bab.png";